import { Skeleton } from "antd";
import { Flex } from "../Flex/Flex";
import { TypographyText } from "../Typography/AntTypography";
import { StyledTile } from "./style";
import { SnapShotTileProps } from "./type";

function SnapShotTile(props: SnapShotTileProps) {
  const {
    heading,
    amount,
    loading,
    count,
    size = "lg",
    direction = "col",
    className,
    extra,
    bottomStrip,
    justify,
    align,
    space,
    headerWidth,
  } = props;

  const Heading = (
    <TypographyText fs={heading.fs} style={{ color: heading.color }}>
      {heading.text}
    </TypographyText>
  );

  const InvoiceCount = (
    <Flex
      vertical
      style={{ width: count.width ? count.width : "100%" }}
      align={count.align ? count.align : "start"}
      space="2"
    >
      <TypographyText fs={count.title.fs} style={{ color: "var(--gray-8)" }}>
        {count.title.value}
      </TypographyText>
      <TypographyText fs={count.fs}>{count.value}</TypographyText>
    </Flex>
  );

  const Header = (
    <Flex
      vertical
      align="start"
      style={{ width: headerWidth ? headerWidth : "100%" }}
      space={bottomStrip ? "2" : "4"}
    >
      {Heading}
      {amount}
    </Flex>
  );

  return (
    <StyledTile
      size={size}
      bottomStrip={bottomStrip ? "strip" : undefined}
      className={className}
      css={{ "--stripColor": bottomStrip?.color }}
    >
      <Skeleton loading={loading} active title={bottomStrip ? false : true}>
        <Flex
          vertical={direction === "col"}
          style={{ width: "100%" }}
          justify={justify}
          align={align}
          space={space}
        >
          {Header}
          {extra ? extra : InvoiceCount}
        </Flex>
      </Skeleton>
    </StyledTile>
  );
}

export { SnapShotTile };
